import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { READ_ONLY_ROLES, constants } from '@shared/constants';
import { MessagesActions, fromAuth } from '@shared/store';

@Injectable({
  providedIn: 'root',
})
export class AccessControlGuard {
  router = inject(Router);

  store = inject(Store);

  userRole$ = this.store.select(fromAuth.selectUserRole);
  hasCreateTransactionAccess$ = this.store.select(fromAuth.selectHasCreateTransactionAccess);

  canActivate(): Observable<boolean> {
    return combineLatest([this.userRole$, this.hasCreateTransactionAccess$]).pipe(
      map(([role, hasCreateTransactionAccess]) => {
        if (READ_ONLY_ROLES.includes(role)) {
          this.router.navigate([constants.HOME_ROUTE]);
          return false;
        }

        if (!hasCreateTransactionAccess) {
          this.store.dispatch(
            MessagesActions.displayError({
              message: 'You do not have access to create transactions. Please contact your administrator to enable transaction solutions.',
              title: 'Access Denied',
            }),
          );
          this.router.navigate([constants.HOME_ROUTE]);
          return false;
        }

        return true;
      }),
    );
  }
}
